import { useEffect } from 'react';
import { useQueryClient } from 'react-query';

// Import store
import { addAppListener } from 'store/store';

// Import hooks
import { useAppDispatch } from 'store/hooks';
import { useProtectedPage } from 'components/utilities';
import { useSummaryStore } from 'components/views/offer_configurator/hooks/useSummaryStore';

// Import actions
import { subscriberLogout } from 'store/features/subscriber/thunk';

// Import helpers
import { removeUserToken } from 'helpers/auth';

export const useClearData = () => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();
	const clearSummaryStore = useSummaryStore((state) => state.clearSummaryStore);
	const clearProtectedPage = useProtectedPage((state) => state.clearProtectedPage);

	// TO DO: probably addListener not working with async thunk

	useEffect(() => {
		const unsubscribe = dispatch(
			addAppListener({
				type: subscriberLogout.fulfilled.type,
				effect: () => {
					queryClient.clear();
					clearSummaryStore();
					clearProtectedPage();
					removeUserToken();
				}
			})
		);

		return unsubscribe;
	}, []);
};
